import { Component, Inject } from '@angular/core';
import { IJOB_DATA } from '../job-injector-data';
import { OverlayService } from 'app/shared/services/overlay.service';
import { JobsService } from '../jobs.service';
import { EJobType } from '../job-type.enum';
import { BzgToastService, BzgModalService, BzgModalRef, BzgToastType } from 'bz-genome-angular';
import { TranslateService } from '@ngx-translate/core';
import { I18nService } from 'i18n/i18n.service';
import * as _ from 'lodash';
import { SavePendingChangesComponent } from '../../../shared/components/save-pending-changes/save-pending-changes.component';
import { IJob } from '../IJob';
import { ShowToastService } from 'app/shared/services/showToast.service';

@Component({
  selector: 'jobs-detail',
  templateUrl: 'jobs-detail.component.html',
  styleUrls: ['jobs-detail.component.scss']
})
export class JobsDetailComponent {
  public currentJob: IJob;
  public jobType  = EJobType.Alarm;
  public title: string;
  public isLoading = false;
  public modalRef: BzgModalRef;

constructor(@Inject(IJOB_DATA) jobData: any, private _overlayService: OverlayService,
    private _jobsService: JobsService, private _toastService: BzgToastService,
    private _translateService: TranslateService,
    private _i18nService: I18nService,
    private _modalService: BzgModalService,
    private _showToastService: ShowToastService) {
    this.currentJob = jobData.job;
    this.jobType = jobData.jobType;
    this.title = jobData.title;
  }

  public async validatePendingChanges(job: IJob) {
    const jobOnServer: IJob = await this._jobsService.getJobById(job.id);
    const isDateDifferent = new Date(job.nextRuntime).getTime() !== new Date(jobOnServer.nextRuntime).getTime();
    const isEnabledDifferent = job.enabled !== jobOnServer.enabled;

    if (isDateDifferent || isEnabledDifferent) {
      this.modalRef = this._modalService.open(SavePendingChangesComponent, {closeOnRouterNavigation: true});
      this.modalRef.afterClosed().subscribe(result => {
        switch (result.action) {
          case 'cancel':
            this.modalRef.close();
            break;
          case 'dontsave':
            this.modalRef.close();
            this.close();
            break;
          case 'save':
            this.updateJob(this.currentJob, true)
            this.modalRef.close();
            break;
          case 'close':
            this.modalRef.close();
            break;
        }
      });
    } else {
      this.close();
    }
  }

  public close() {
    this._overlayService.hide();
  }
  public async updateJob(job: IJob, closeAfter = false) {
    this.isLoading = true;
    try {
      await this._jobsService.updateJob(this.currentJob.id, job);
      this.currentJob = await this._jobsService.getJobById(job.id);
      this.currentJob.radNumber = job.radNumber;
      this._showToastService.showToast(this._i18nService.instant('GLOBAL.THE_OPERATION_WAS_SAVED_SUCCESSFULLY'), 'success');
      this.isLoading = false;
    } catch (error) {
      this._showToastService.showToast(this._i18nService.instant('GLOBAL.AN_ERROR_HAS_OCCURRED'), 'error');
      this.isLoading = false;
    }
    if (closeAfter) {
      this.close()
    }
  }

}
